import { STATSIG_EXPERIMENTS_CONFIG } from '@src/config/statsig-experiments.config'
import { STATSIG_EXPERIMENTS, useStatsigExperiment } from '@src/experiments/statsig-integration'

export default function useHideKlarnaExp(): {
  hideKlarna: boolean
} {
  const { experimentBucket, init } = useStatsigExperiment(STATSIG_EXPERIMENTS.HIDE_KLARNA_EXP)
  const hideKlarna =
    init && experimentBucket === STATSIG_EXPERIMENTS_CONFIG[STATSIG_EXPERIMENTS.HIDE_KLARNA_EXP].buckets?.show

  return { hideKlarna }
}
